// src/components/common/DeviceTzWarning.js — tzcanada-9b4e2f17
//
// Amber strip at the top of the app when THIS device's time-zone data is too old for the company's
// zone, or the computer can't name its zone (src/utils/deviceTzCheck.js has the rule). Display
// only: saved jobs are right on the server either way. Dismissing hides it for this browser tab
// (sessionStorage), so a device that is still out of date shows it again next time.
import React, { useMemo, useState } from 'react';
import { checkDeviceTz } from '../../utils/deviceTzCheck';

const KEY = 'spatchy.deviceTzWarningDismissed';

const DeviceTzWarning = ({ companyTz }) => {
    const problem = useMemo(() => checkDeviceTz(companyTz), [companyTz]);
    const [dismissed, setDismissed] = useState(() => {
        try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
    });
    if (!problem || dismissed) return null;
    const dismiss = () => {
        try { sessionStorage.setItem(KEY, '1'); } catch { /* storage unavailable */ }
        setDismissed(true);
    };
    return (
        <div role="alert" className="no-print mx-4 mt-3 mb-1 p-3 bg-amber-50 border border-amber-300 rounded-lg flex items-start gap-3 text-sm text-amber-900">
            <span aria-hidden="true" className="mt-0.5">⚠️</span>
            <p className="flex-1">{problem.message}</p>
            <button type="button" onClick={dismiss} className="shrink-0 px-2 py-0.5 rounded text-amber-900 hover:bg-amber-100" aria-label="Dismiss">✕</button>
        </div>
    );
};

export default DeviceTzWarning;
